export enum ValidationStates {
    Unknown = 0,
    Keep = 1,
    Discard = 2
}

export enum SyncStatus {
    Pending = 0,
    Disabled = 1, // no sync is set up for the job
    Synced = 2,
    Error = 3
}

export enum MeasurementType {
    OxygenSaturation = 0,
    OxygenTemperature,
    Conductivity,
    Salinity,
    OxygenConcentration
}

export const MeasurementTypeMapper = {
    0: "Oxygen Saturation",
    1: "Oxygen Temperature",
    2: "Conductivity",
    3: "Salinity",
    4: "Oxygen Concentration"
}

// JavaScript interface for Customer
export interface User {
    id: string;
    name: string;
    email: string;
    username: string;
    password: string;
    deployments: Deployment[];
}

export interface Job {
    id: string;
    name: string;
    hasEnded: boolean;
    createdTime: Date;
    endedTime?: Date;
    latitude: number;
    longitude: number;
    dataForwardingEnabled: boolean;

    // related owner
    ownerId: string;
    owner: User;

    // related deployments
    deployments: Deployment[];
}

// JavaScript interface for Deployment
export interface Deployment {
    id: string;
    name: string;
    deploymentTime: Date;
    hasEnded: boolean;
    currentBuoyId?: string;
    currentBuoy: BuoyDeployment;

    owner: User;
    ownerId?: string;

    // reference to Job that this deployment is related to
    jobId?: string;
    job?: Job;

    // all measurements for this deployment
    deploymentDataEntries: DeploymentDataEntry[];
}

// JavaScript interface for BuoyDeployment
export interface BuoyDeployment {
    buoyId: string;
    deploymentId: string;
    deployment: Deployment;
}

// dto strictly for referencing a buoy deployment relation, used when deleting, updating, etc
export interface BuoyDeploymentRelation {
    buoyId: string;
    deploymentId: string;
}


export interface Measurement {
    id: string;
    statusCode: number;
    value: number;
    type: MeasurementType;
    deploymentDataEntry: DeploymentDataEntry;
    deploymentDataEntryId: string;
}



export interface UserDto {
    id: string;
    name: string;
    email: string;
    username: string;
    isGod: boolean;
}

export interface DeploymentGps {
    id: string;
    statusCode: number;
    time: Date;
    latitude: number;
    longitude: number;
    sattelites: number;
    hdop: number;
    fixQuality: number;
    connectTimeS: number;

    // Relations
    deploymentDataEntry?: DeploymentDataEntry;
    deploymentDataEntryId?: string;
}


// JavaScript interface for DeploymentDataEntry
export interface DeploymentDataEntry {
    id: string;
    time: Date;
    skippedCycles: number;
    skippedTransmissions: number;
    validationStatus: ValidationStates;
    syncStatus: SyncStatus;

    // Related Deployment
    deployment: Deployment;
    deploymentId: string;

    // All related measurements
    measurements: Measurement[];

    // Diagnostics for deployment
    // powerDiagnosticsEntries: PowerDiagnosticsEntry[];
    // telemetryStats?: TelemetryStats;

    // Reference to GPS coordinates
    gpsCoordinates?: DeploymentGps;
}

